import { render } from "./programKegiatan.vue?vue&type=template&id=70be9705"
import script from "./programKegiatan.vue?vue&type=script&lang=js"
export * from "./programKegiatan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__